import Sloth from '../Sloth';
var $ = require("jquery");

@Sloth.component({
    defaultOptions : {}
})


export default class Collapse {
    onInit() {
        const obj = this.dom;
        const options = this.options;

        $(obj).on("click", ".Collapse-label", function(e) {
            $(e.delegateTarget).toggleClass("open")
        })
    }
}



/** WEBPACK FOOTER **
 ** ./components/Collapse/index.js
 **/